import { render, staticRenderFns } from "./ListTypeSelection.vue?vue&type=template&id=2c7e1d9e&scoped=true&"
import script from "./ListTypeSelection.vue?vue&type=script&lang=js&"
export * from "./ListTypeSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7e1d9e",
  null
  
)

export default component.exports